import { cva as e } from "class-variance-authority";
// src/design/filter/style.ts
var t = e("relative inline-flex flex-col gap-1"), n = e("relative flex", {
	variants: { labelPosition: {
		top: "flex-col items-start gap-1",
		left: "flex-row items-center gap-2"
	} },
	defaultVariants: { labelPosition: "top" }
}), r = e("text-label font-medium text-foreground"), i = e([
	"inline-flex items-center justify-between gap-2",
	"rounded-md border pl-2 pr-1",
	"font-medium transition-all duration-normal ease-enter",
	"cursor-pointer outline-hidden",
	"hover:border-border",
	"focus-ring",
	"disabled:cursor-not-allowed disabled:opacity-50"
], {
	variants: {
		size: {
			sm: "h-8 text-xs",
			md: "h-9 text-sm",
			lg: "h-10 text-md"
		},
		selected: {
			false: [
				"!border-border",
				"bg-filter-bg",
				"hover:bg-filter-hover"
			],
			true: ["!border-border", "hover:bg-secondary"]
		}
	},
	defaultVariants: {
		size: "sm",
		selected: !1
	}
}), a = e(["flex h-4 w-4 shrink-0 items-center justify-center", "transition-colors duration-normal"], {
	variants: { selected: {
		false: "text-muted-foreground",
		true: "text-muted-foreground"
	} },
	defaultVariants: { selected: !1 }
}), o = e(["flex-1 text-left truncate transition-colors duration-normal"], {
	variants: { selected: {
		false: "text-foreground",
		true: "text-primary font-medium"
	} },
	defaultVariants: { selected: !1 }
}), s = e([
	"flex h-4 w-4 shrink-0 items-center justify-center",
	"transition-all duration-normal",
	"data-[state=open]:rotate-180"
], {
	variants: { selected: {
		false: "text-muted-foreground",
		true: "text-primary"
	} },
	defaultVariants: { selected: !1 }
}), c = e("relative inline-flex items-center"), l = e("flex h-6 w-6 shrink-0"), u = e([
	"absolute right-1 top-1/2 -translate-y-1/2",
	"flex h-6 w-6 shrink-0 items-center justify-center rounded-sm cursor-pointer",
	"text-muted-foreground",
	"transition-all duration-fast",
	"hover:bg-primary/8",
	"hover:text-foreground",
	"focus-ring"
]), d = e([
	"flex h-6 w-6 shrink-0 items-center justify-center rounded-sm cursor-pointer",
	"text-muted-foreground",
	"absolute right-2 top-1/2 -translate-y-1/2",
	"transition-all duration-fast",
	"hover:bg-muted",
	"hover:text-foreground"
]), f = e(""), p = e([
	"w-full min-w-[200px]",
	"overflow-hidden rounded-md border shadow-floating",
	"border-input",
	"bg-popover z-floating",
	"animate-in fade-in-0 zoom-in-95 duration-normal"
]);
e([
	"flex items-center gap-2",
	"border-b px-3 py-2",
	"border-input"
]), e(["flex h-4 w-4 shrink-0 items-center justify-center", "text-muted-foreground"]), e([
	"flex-1 bg-transparent text-sm outline-hidden",
	"text-foreground",
	"placeholder:text-muted-foreground"
]);
var m = e("max-h-60 overflow-y-auto p-1");
e([
	"px-2 py-1.5",
	"text-xs font-semibold",
	"text-muted-foreground"
]);
var h = e([
	"relative flex w-full items-center",
	"cursor-pointer select-none",
	"rounded-sm px-2 py-1.5",
	"text-sm outline-hidden",
	"transition-all duration-fast ease-enter",
	"text-foreground",
	"hover:bg-muted",
	"focus:bg-muted",
	"data-highlighted:bg-muted",
	"data-disabled:pointer-events-none data-disabled:opacity-50"
]), g = e("flex-1 truncate"), _ = e(["flex h-4 w-4 shrink-0 items-center justify-center mr-2", "text-primary"]), v = e([
	"h-8 w-full rounded-md border bg-back pl-8 pr-3 text-sm",
	"text-foreground placeholder:text-muted-foreground",
	"border-input",
	"focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 focus-visible:outline-hidden",
	"transition-all"
]), y = e("flex items-center gap-2 px-2 py-2 border-b border-border"), b = e([
	"absolute left-2 top-1/2 -translate-y-1/2",
	"flex h-4 w-4 items-center justify-center",
	"text-muted-foreground"
]), x = e([
	"flex h-9 w-9 shrink-0 items-center justify-center rounded-md border",
	"border-border bg-back text-muted-foreground",
	"transition-colors",
	"hover:bg-accent hover:text-foreground"
]), S = e([
	"w-full text-left px-2 py-1.5 text-sm rounded-sm transition-colors",
	"text-destructive",
	"hover:bg-destructive/10"
]);
export { x as filterActionButton, S as filterClearButton, l as filterClearSpacer, u as filterClearTrigger, p as filterContent, n as filterControl, s as filterIndicator, h as filterItem, m as filterItemGroup, _ as filterItemIndicator, g as filterItemText, r as filterLabel, f as filterPositioner, t as filterRoot, b as filterSearchIconWrapper, v as filterSearchInput, y as filterSearchWrapper, i as filterTrigger, a as filterTriggerIcon, c as filterTriggerWrap, o as filterValueText, d as searchClearTrigger };

//# sourceMappingURL=style.js.map